var c = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [o, a] of e)
    r[o] = a;
  return r;
};
export {
  c as default
};
